(() => {
  if (window.meloraTimelineScrollLoaded) return;
  window.meloraTimelineScrollLoaded = true;

  const timelines = new Set();
  let frame = 0;
  const update = () => {
    frame = 0;
    const readingLine = document.documentElement.clientHeight * 0.6;
    const positions = [];
    timelines.forEach(timeline => {
      if (!timeline.isConnected) {
        observer.unobserve(timeline);
        timelines.delete(timeline);
        return;
      }
      const bounds = timeline.getBoundingClientRect();
      const progress = bounds.height > 0
        ? Math.max(0, Math.min(1, (readingLine - bounds.top) / bounds.height))
        : 0;
      const markers = Array.from(timeline.querySelectorAll('.mlv2__step')).map(step => {
        const marker = getComputedStyle(step, '::before');
        const center = step.getBoundingClientRect().top + parseFloat(marker.top) + parseFloat(marker.height) / 2;
        return [step, progress > 0 && readingLine >= center];
      });
      positions.push([timeline, `${(progress * 100).toFixed(3)}%`, markers]);
    });
    positions.forEach(([timeline, progress, markers]) => {
      timeline.style.setProperty('--ml-timeline-progress', progress);
      timeline.setAttribute('data-scroll-ready', '');
      markers.forEach(([step, reached]) => step.setAttribute('data-reached', String(reached)));
    });
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const observer = new ResizeObserver(schedule);
  const init = (root = document) => {
    root.querySelectorAll('[data-mlv2-scroll-timeline]').forEach(timeline => {
      if (timelines.has(timeline)) return;
      timelines.add(timeline);
      observer.observe(timeline);
    });
    schedule();
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('load', schedule, true);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    timelines.forEach(timeline => {
      if (!event.target.contains(timeline)) return;
      observer.unobserve(timeline);
      timelines.delete(timeline);
    });
    schedule();
  });
  document.fonts?.ready.then(schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
})();
